<template>
  <div :class="['bg-primary', gdqmodeclass]">
    <BaseModal v-model="gdq_recertification" size="lg" @hidden="recertify_redirect" ok-only>
      <div v-html="gdq_recertification_text" />
    </BaseModal>

    <nav class="navbar navbar-expand-lg navbar-dark bg-primary container-xl mx-auto sticky-top">
      <router-link class="navbar-brand item-text" to="/">
        <LogoStyleGuide />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        aria-label="Toggle navigation"
        @click="navOpen = !navOpen"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div :class="['collapse navbar-collapse', { show: navOpen }]" id="nav-collapse">
        <ul class="navbar-nav ms-auto bg-primary ps-2" :class="gdqmodeclass">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ disabled: consultantstatus && consultantstatus.can_do_survey === '0' }"
              href="/tutorials"
            >Resources</a>
          </li>
          <li v-if="faqs === true" class="nav-item">
            <a
              class="nav-link"
              :class="{ disabled: consultantstatus && consultantstatus.can_do_survey === '0' }"
              href="/faq"
            >Support</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">
              <span>Notifications <span class="noti-circle">1</span></span>
            </a>
          </li>
          <li class="nav-item dropdown name-dropdown">
            <BaseDropdown right variant="primary">
              <template #button-content>
                <span class="text-white">Namn Namnsson</span>
              </template>
              <li v-if="is_consultant" class="dropdown-item">
                <router-link class="text-primary" to="/"><i class="fa-regular fa-gauge"></i>Dashboard</router-link>
              </li>
              <li v-if="is_consultant" class="dropdown-item">
                <router-link to="/profile"><i class="fa-regular fa-user"></i>My Profile</router-link>
              </li>
              <li v-if="is_consultant" class="dropdown-item">
                <router-link to="#"><i class="fa-regular fa-square-poll-vertical"></i>My Surveys</router-link>
              </li>
              <li v-if="is_consultant" class="dropdown-item">
                <router-link to="#"><i class="fa-regular fa-credit-card-blank"></i>Billing & Payments</router-link>
              </li>
              <li v-if="is_admin" class="dropdown-item">
                <router-link to="#"><i class="fa-regular fa-user-cog"></i>Admin</router-link>
              </li>
              <li class="dropdown-item">
                <button class="btn btn-link text-danger p-0" type="button" @click="logout">Log out</button>
              </li>
            </BaseDropdown>
          </li>
        </ul>
      </div>
    </nav>

    <BaseModal v-model="showmessages" title="System Messages" size="lg" ok-only>
      <div v-for="message in messagesmenu" :key="message.id" class="ps-4">
        <div
          class="row col-12 mb-1 py-1"
          :class="`bg-${messagevariants[message.message_severity]}`"
          style="cursor:pointer"
          @click.prevent="message_show(message.id)"
        >
          <span class="gdq-w-50px pt-1">
            <span
              :title="message.status==='read'?'Set as unread':'Set as read'"
              @click.prevent.stop="message_setstatus(message.id,message.status==='read'?'unread':'read')"
            >
              <fa-icon :icon="message.status==='read'?'envelope-open':'envelope'" class="me-2 mt-0" />
            </span>
            <fa-icon :icon="showingmessage===message.id?'chevron-down':'chevron-right'" class="me-2 mt-0" />
          </span>
          <span class="gdq-w-50px pt-1">
            {{ message.message_activation_date }}
          </span>
          <span class="pt-1">
            {{ message.message_heading }}
          </span>
        </div>
        <div v-show="showingmessage===message.id" v-html="message.message_message" />
      </div>
    </BaseModal>

    <BaseModal v-model="showmain" size="lg" title="Messages from GDQ Associates" ok-only>
      <div
        v-for="message in messagesmain"
        :key="message.id"
        class="alert"
        :class="`alert-${messagevariants[message.message_severity] || 'primary'}`"
        role="alert"
      >
        <h3>{{ message.message_heading }}</h3>
        <span v-html="message.message_message" />
      </div>
      <template #modal-footer>
        <div class="d-flex align-items-center w-100">
          <label class="form-check-label me-2">
            <input v-model="dontshowmotd" class="form-check-input me-1" type="checkbox">
            Don't show this message again
          </label>
          <button class="btn btn-primary ms-auto" @click.prevent="main_close()">OK</button>
        </div>
      </template>
    </BaseModal>
  </div>
</template>
<script>
import BaseDropdown from '../base/BaseDropdown.vue'
import BaseModal from '../base/BaseModal.vue'
import LogoStyleGuide from './LogoStyleGuide.vue'
export default {
  components: {
    BaseDropdown,
    BaseModal,
    LogoStyleGuide
  },
  data () {
    return {
      navOpen: false,
      anon: this.$store.state.anon,
      asadmin: this.$store.state.asadmin,
      user: this.$store.state.user,
      profile: this.$store.state.profile,
      gdqmodeclass: 'bg-primary',
      search: '',
      is_consultant: false,
      is_tot: false,
      is_admin: false,
      lastlogin_months: 0,
      gdq_recertification_months: 1000,
      gdq_recertification_text: '',
      gdq_recertification: false,
      faqs: false,
      messagesmenu: [],
      messagesmain: [],
      showmessagesicon: false,
      showmessages: false,
      showmain: false,
      showingmessage: 0,
      unreadmessages: 0,
      dontshowmotd: false,
      messagevariants: [
        '',
        '',
        '',
        'warning',
        'danger'
      ],
      nowdate: new Date().toISOString().substring(0, 10)
    }
  },
  computed: {
    consultantstatus: function () {
      const consultantstatus = this.$store.state.consultantstatuses.find(s => s.id === this.profile.consultantstatus_id)
      return consultantstatus
    }
  },
  created () {
    this.user_get()
    // this.check_oldlogin();
    this.messages_get()
    this.faqs_get()
    this.user_role_set()
  },
  methods: {
    toggleanon () {
      this.$store.dispatch('toggleanon')
    },
    recertify_redirect () {
      this.$router.push('/login')
    },
    check_oldlogin () {
      // This one works, but we need to reset i_user.last_login to i_user.prev_login,
      // otherwise the user can log in the second time
      this.lastlogin_months = 0
      if (this.user.prev_login !== null) {
        const d1 = new Date(this.user.prev_login.replace(' ', 'T'))
        const d2 = new Date()
        let months = 0
        months = (d2.getFullYear() - d1.getFullYear()) * 12
        months -= d1.getMonth() + 1
        months += d2.getMonth() + 1
        this.lastlogin_months = months
        this.$store.dispatch('syspref_get', { name: 'gdq_recertification_months' })
          .then((resp) => {
            this.gdq_recertification_months = resp.data.value
            if (parseInt(this.lastlogin_months) >= parseInt(this.gdq_recertification_months)) {
              this.$store.dispatch('syspref_get', { name: 'gdq_recertification_text' })
                .then((resp) => {
                  this.gdq_recertification_text = resp.data.value
                  this.gdq_recertification = true
                })
            }
          })
      }
    },
    user_get () {
      this.$store.dispatch('user_fetch').then(() => {
        this.user = this.$store.state.user
      })
    },
    main_close () {
      this.showmain = false
      if (this.dontshowmotd === true) {
        for (let i = 0; i < this.messagesmain.length; i++) {
          this.message_setstatus(this.messagesmain[i].id, 'read')
        }
      }
    },
    messages_show () {
      this.showmessages = true
      this.showingmessage = 0
    },
    message_show (message_id) {
      this.showingmessage = this.showingmessage === message_id ? 0 : message_id
      if (this.showingmessage !== 0) {
        this.message_setstatus(this.showingmessage, 'read')
      }
    },
    messages_get () {
      this.$store.dispatch('usersystemmessages_fetch', { user_id: this.$store.state.user_id })
        .then((resp) => {
          this.messagesmenu = resp.data.result
          this.showmessagesicon = this.messagesmenu.length > 0
          const unreadlist = this.messagesmenu.filter(m => m.status === 'unread')
          this.unreadmessages = unreadlist.length
          this.messagesmain = this.messagesmenu.filter(m => m.status === 'unread' && m.always_show === 1)
          this.showmain = this.messagesmain.length > 0 && this.$route.path === '/'
        })
    },
    message_setstatus (message_id, status) {
      this.$store.dispatch('usersystemmessage_setstatus', { user_id: this.$store.state.user_id, message_id, message_status: status })
        .then(() => {
          this.messages_get()
        })
    },
    logout: function () {
      this.$store
        .dispatch('logout', {})
        .then(() => this.$router.push('/login'))
        // eslint-disable-next-line
        .catch(err => console.log(err));
    },
    user_role_set () {
      for (let i = 0; i < this.$store.state.user_usergroups.length; i++) {
        if (this.$store.state.user_usergroups[i].usergroup_id === 1) { this.is_consultant = true }
        if (this.$store.state.user_usergroups[i].usergroup_id === 2) { this.is_admin = true }
        if (this.$store.state.user_usergroups[i].usergroup_id === 8) { this.is_tot = true }
      }
    },
    user_status_set () {

    },
    faqs_get () {
      this.$store.dispatch('records_readall', { table_name: 'g_faq' })
        .then((resp) => {
          if (resp.data.result.length > 0) {
            this.faqs = true
          }
        })
    }
  }
}
</script>
<style scoped>
a.nav-link {
  color: white !important;
}
a.nav-link.dropdown-toggle {
  color: white !important;
}
</style>
